export enum DefaultPriceType {
    publicPunctualHandling,
    exceptionalTransport,
    precariousConcessions,
    roadTransport,
    minTonnageNotReached
}

export const DefaultPriceTypeName = new Map<number, string>([
    [DefaultPriceType.publicPunctualHandling, 'PublicPunctualHandling'],
    [DefaultPriceType.exceptionalTransport, 'ExceptionalTransport'],
    [DefaultPriceType.precariousConcessions, 'PrecariousConcessions'],
    [DefaultPriceType.roadTransport, 'RoadTransport'],
    [DefaultPriceType.minTonnageNotReached, 'MinTonnageNotReached']
]);


export const NameToDefaultPriceType = new Map<string, DefaultPriceType>([
    ['PublicPunctualHandling', DefaultPriceType.publicPunctualHandling],
    ['ExceptionalTransport', DefaultPriceType.exceptionalTransport],
    ['PrecariousConcessions', DefaultPriceType.precariousConcessions],
    ['RoadTransport', DefaultPriceType.roadTransport],
    ['MinTonnageNotReached', DefaultPriceType.minTonnageNotReached],
]);